import { HttpClient } from '@angular/common/http';
import {Inject, Injectable} from '@angular/core';
import {BehaviorSubject, firstValueFrom, map, Observable, switchMap, take, tap} from 'rxjs';
import {IDictionaryResolverService} from './i-dictionary-resolver-service';
import {TJsonMap} from "@zaeper/core-lib";
import {IDictionaryService, ILanguageStateService} from "@zaeper/localization-lib";
import {languageStateServiceInjectionToken} from "../language/languageStateServiceInjectionToken";
import {dictionaryServiceInjectionToken} from "@zaeper/angular-localization-lib";

@Injectable()
export class DictionaryResolverService implements IDictionaryResolverService {
  private static _DICTIONARY_NAMES: string[] = ["main", "forms", "registry"];

  constructor(
    @Inject(languageStateServiceInjectionToken)
    private _languageStateService: ILanguageStateService,
    @Inject(dictionaryServiceInjectionToken)
    private _dictionaryService: IDictionaryService,
    private _httpClient: HttpClient
  ) {
  }

  async resolve(): Promise<void> {
   for (const dictName of DictionaryResolverService._DICTIONARY_NAMES) {
     await this._registerDictionary(dictName);
   }
  }

  private async _registerDictionary(dictName: string): Promise<void> {
    const activeLanguage: string = await firstValueFrom(this._languageStateService.language$);
    const dictionaryContent = await firstValueFrom(this._httpClient.get(`/dicts/${dictName}/${activeLanguage}.json`));
    const dict: TJsonMap = <TJsonMap>dictionaryContent;
    this._dictionaryService.setDictionary(dictName, activeLanguage, dict);
  }
}
